export enum AppThemeColors{
    Primary = "primary",
    Secondary = "secondary",
    Tertiary = "tertiary",
    Success = "success",
    Warning = "warning",
    Danger = "danger",
    Dark = "dark",
    Medium = "medium",
    Light = "light",
    OliveGreen = "olive-green",
    DarkCyan = "dark-cyan",
    BabyBlue = "baby-blue",
    Purple = "purple"
}